import { ACTIONS } from '../actions';

const INITIAL_STATE = {
    tab: 0,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.CHANGE_TAB:
            return { ...state, tab: action.payload };
        default:
            return state;
    }
}